module.exports = __webpack_public_path__ + "static/img/ayrm.bb75cc4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/ayrm.png
// module id = bqgM
// module chunks = 0